// extracted by mini-css-extract-plugin
module.exports = {"appLoaderContainer":"loader_appLoaderContainer__ukVYx","appLoader":"loader_appLoader__3Qmeo"};